import { Howler } from 'howler'
import pLimit from 'p-limit'
import { AudioContext as StandardizedAudioContext } from 'standardized-audio-context'
import { fetchWithCors } from '../network'
import { isRemoteAsset } from './is-remote-asset'
import type { AudioData } from './types'

const limit = pLimit(3)

const metadataCache: Record<string, AudioData> = {}

const fn = async (src: string, audioBuffer: AudioBuffer | null = null) => {
  if (metadataCache[src]) {
    return metadataCache[src]
  }
  const isHowlerPromiseSupported =
    typeof Promise !== 'undefined' && Howler.ctx?.decodeAudioData.length === 1

  let audioContext = isHowlerPromiseSupported
    ? Howler.ctx
    : new StandardizedAudioContext()

  let wave = audioBuffer
  if (!wave) {
    const response = await fetchWithCors(src)
    const arrayBuffer = await response.arrayBuffer()
    wave = await audioContext.decodeAudioData(arrayBuffer)
  }

  let channelWaveforms: Float32Array[] = []
  try {
    channelWaveforms = new Array(wave.numberOfChannels)
      .fill(true)
      .map((_, channel) => {
        return wave!.getChannelData(channel)
      })
  } catch {
    // no_op
  }

  const metadata: AudioData = {
    channelWaveforms,
    sampleRate: audioContext.sampleRate,
    durationInSeconds: wave.duration,
    numberOfChannels: wave.numberOfChannels,
    resultId: String(Math.random()),
    isRemote: isRemoteAsset(src)
  }

  metadataCache[src] = metadata

  return metadata
}

export const getAudioData = (
  src: string,
  audioBuffer: AudioBuffer | null = null
) => {
  return limit(fn, src, audioBuffer)
}
